import { render, staticRenderFns } from "./SyncTableFlagInca.vue?vue&type=template&id=c936b5d0&scoped=true&lang=pug"
import script from "./SyncTableFlagInca.vue?vue&type=script&lang=js"
export * from "./SyncTableFlagInca.vue?vue&type=script&lang=js"
import style0 from "./SyncTableFlagInca.vue?vue&type=style&index=0&id=c936b5d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c936b5d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c936b5d0')) {
      api.createRecord('c936b5d0', component.options)
    } else {
      api.reload('c936b5d0', component.options)
    }
    module.hot.accept("./SyncTableFlagInca.vue?vue&type=template&id=c936b5d0&scoped=true&lang=pug", function () {
      api.rerender('c936b5d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SyncTableFlagInca.vue"
export default component.exports